module.exports = __webpack_public_path__ + "img/tcbg.74d2e6f0.png";